(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mom-bundle-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

    const languageAliases = {
      en: ['english', 'englisch', 'anglais'],
      de: ['german', 'deutsch', 'allemand'],
      fr: ['french', 'francais', 'franzosisch', 'franzoesisch']
    };

    const formatAliases = {
      boxed: ['boxed kit', 'boxed', 'physical game', 'physical'],
      digital: ['digital access only', 'digital access', 'digital game', 'digital', 'download']
    };

    const mediumAliases = ['medium', 'mittel', 'mittelgross', 'mittelgros', 'intermediaire'];

    const matchesAlias = (value, aliases) => {
      const normalized = normalize(value);
      return aliases.some((alias) => normalized === alias || normalized.includes(alias));
    };

    const playerValuePattern = /\d+\s*(?:(?:-|–|a|to)\s*\d+|\+)/;

    const variantControlType = (select) => {
      const values = [...select.options].map((option) => option.value);
      const allLanguageAliases = [...new Set(Object.values(languageAliases).flat())];

      if (values.some((value) => matchesAlias(value, [...formatAliases.boxed, ...formatAliases.digital]))) {
        return 'format';
      }

      if (values.length && values.every((value) => matchesAlias(value, allLanguageAliases))) {
        return 'language';
      }

      if (values.some((value) => playerValuePattern.test(normalize(value)))) {
        return 'players';
      }

      const optionSlug = normalize(select.closest('.variant-input-wrapper')?.dataset.optionSlug);
      if (
        ['difficulty', 'schwierigkeit', 'difficulte'].some((alias) => optionSlug.includes(alias))
        || values.some((value) => matchesAlias(value, mediumAliases))
      ) {
        return 'difficulty';
      }

      return null;
    };

    const playerValue = (value, locale) => {
      const normalized = normalize(value);
      const range = normalized.match(/(\d+)\s*(?:-|–|a|to)\s*(\d+)/);
      if (range) {
        if (locale === 'fr') return `${range[1]} à ${range[2]} joueurs`;
        if (locale === 'de') return `${range[1]}–${range[2]} Spieler`;
        return `${range[1]}–${range[2]} players`;
      }

      const plus = normalized.match(/(\d+)\s*\+/);
      if (plus) {
        if (locale === 'fr') return `${plus[1]} joueur${plus[1] === '1' ? '' : 's'} et +`;
        if (locale === 'de') return `${plus[1]}+ Spieler`;
        return `${plus[1]}+ players`;
      }

      return value;
    };

    const localizedVariantValue = (root, value, type) => {
      const locale = root.dataset.locale in languageAliases ? root.dataset.locale : 'en';

      if (type === 'format') {
        if (matchesAlias(value, formatAliases.boxed)) return root.dataset.formatBoxed;
        if (matchesAlias(value, formatAliases.digital)) return root.dataset.formatDigital;
      }

      if (type === 'language') {
        if (matchesAlias(value, languageAliases.en)) return root.dataset.languageEnglish;
        if (matchesAlias(value, languageAliases.de)) return root.dataset.languageGerman;
        if (matchesAlias(value, languageAliases.fr)) return root.dataset.languageFrench;
      }

      if (type === 'players') return playerValue(value, locale);
      if (type === 'difficulty' && matchesAlias(value, mediumAliases)) return root.dataset.difficultyMedium;

      return value;
    };

    const variantLabel = (root, type) => ({
      format: root.dataset.formatLabel,
      difficulty: root.dataset.difficultyLabel,
      players: root.dataset.playersLabel,
      language: root.dataset.languageLabel
    })[type];

    const localizeVariantControls = (root, scope = root) => {
      scope.querySelectorAll('.variant-input-wrapper select').forEach((select) => {
        const type = variantControlType(select);
        if (!type) return;

        const wrapper = select.closest('.variant-input-wrapper');
        const label = wrapper?.querySelector('label');
        label?.querySelector('[data-mom-option-label]')?.remove();
        const valueNode = label?.querySelector('span');
        const labelCopy = variantLabel(root, type);

        select.querySelectorAll('option').forEach((option) => {
          option.textContent = localizedVariantValue(root, option.value, type);
        });

        if (label && valueNode && labelCopy) {
          let labelTextNode = [...label.childNodes].find((node) => node.nodeType === 3);
          if (!labelTextNode) {
            labelTextNode = document.createTextNode('');
            label.insertBefore(labelTextNode, valueNode);
          }
          labelTextNode.textContent = `${labelCopy}: `;
          valueNode.textContent = localizedVariantValue(root, select.value, type);
          select.setAttribute('aria-label', `${labelCopy}: ${valueNode.textContent}`);
        }
      });
    };

    const localizeSummaryOptions = (root) => {
      root.querySelectorAll('.product-bundle__body li').forEach((item) => {
        const value = item.textContent.trim();
        let type = null;
        if (matchesAlias(value, [...formatAliases.boxed, ...formatAliases.digital])) type = 'format';
        else if (Object.values(languageAliases).some((aliases) => matchesAlias(value, aliases))) type = 'language';
        else if (playerValuePattern.test(normalize(value))) type = 'players';
        else if (matchesAlias(value, mediumAliases)) type = 'difficulty';
        if (type) item.textContent = localizedVariantValue(root, value, type);
      });
    };

    const emitAnalytics = (root, name, detail = {}) => {
      const payload = { event: `bundle_${name}`, ...detail };
      root.dispatchEvent(new CustomEvent(`mom:bundle_${name}`, { bubbles: true, detail: payload }));

      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(payload);
      }
    };

    const initLanguageVariants = (root) => {
      const locale = root.dataset.locale in languageAliases ? root.dataset.locale : 'en';
      const desiredAliases = languageAliases[locale];
      const everyAlias = [...new Set(Object.values(languageAliases).flat())];

      root.querySelectorAll('[data-language-shell]').forEach((shell) => {
        const card = shell.querySelector('.product-card');
        const picker = card?.querySelector('variant-picker');
        const variantsNode = picker?.querySelector('[data-variants]');
        const form = card?.querySelector('form[is="product-bundle-form"]');
        const submit = form?.querySelector('[type="submit"]');
        const bundleKind = shell.closest('[data-bundle-kind]')?.dataset.bundleKind;
        const languageRequired = shell.dataset.languageRequired !== 'false';

        const markReady = () => {
          shell.dataset.languageReady = 'true';
          shell.removeAttribute('inert');
          submit?.removeAttribute('aria-busy');
          localizeVariantControls(root, card || root);
          window.requestAnimationFrame(() => localizeVariantControls(root, card || root));
          const controlledBundle = document.getElementById(form?.getAttribute('aria-controls'));
          controlledBundle?._momBundleUpdate?.();
        };

        const markUnavailable = () => {
          if (!languageRequired) {
            markReady();
            return;
          }

          shell.dataset.languageReady = 'unavailable';
          shell.removeAttribute('inert');
          if (submit) submit.disabled = true;
          if (card && !card.querySelector('.mom-bundle__language-warning')) {
            const warning = document.createElement('p');
            warning.className = 'mom-bundle__language-warning';
            warning.setAttribute('role', 'status');
            warning.textContent = root.dataset.languageUnavailable;
            card.appendChild(warning);
          }
          const controlledBundle = document.getElementById(form?.getAttribute('aria-controls'));
          controlledBundle?._momBundleUpdate?.();
        };

        if (!picker || !variantsNode || !form || !submit) {
          markReady();
          return;
        }

        let variants = [];
        try {
          variants = JSON.parse(variantsNode.textContent || '[]');
        } catch (error) {
          markUnavailable();
          return;
        }

        const languageBearing = variants.some((variant) =>
          (variant.options || []).some((option) => matchesAlias(option, everyAlias))
        );

        const selects = [...picker.querySelectorAll('select')];
        const languageSelect = selects.find((select) =>
          [...select.options].some((option) => matchesAlias(option.value, everyAlias))
        );

        if (bundleKind === 'cold' && locale !== 'fr') {
          languageSelect?.closest('.variant-input-wrapper')?.setAttribute('hidden', '');
        }

        if (!languageBearing) {
          markReady();
          return;
        }

        const desiredVariant = variants.find((variant) =>
          variant.available && (variant.options || []).some((option) => matchesAlias(option, desiredAliases))
        );

        if (!desiredVariant) {
          markUnavailable();
          return;
        }

        const selectedNode = picker.querySelector('[data-selected-variant]');
        let selectedId = null;
        try {
          selectedId = JSON.parse(selectedNode?.textContent || 'null')?.id;
        } catch (error) {
          selectedId = null;
        }

        if (String(selectedId) === String(desiredVariant.id)) {
          markReady();
          return;
        }

        let changedSelect = null;

        selects.forEach((select, index) => {
          const desiredValue = desiredVariant[`option${index + 1}`];
          const matchingOption = [...select.options].find((option) => option.value === desiredValue);
          if (!matchingOption) return;

          select.value = desiredValue;
          [...select.options].forEach((option) => option.toggleAttribute('selected', option === matchingOption));
          changedSelect = select;
        });

        if (!changedSelect) {
          markUnavailable();
          return;
        }

        submit.setAttribute('aria-busy', 'true');
        form.addEventListener('variant:change', markReady, { once: true });
        changedSelect.dispatchEvent(new Event('change', { bubbles: true }));

        window.setTimeout(() => {
          if (shell.dataset.languageReady !== 'true') markUnavailable();
        }, 6000);
      });
    };

    const initSection = (root) => {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const tabs = [...root.querySelectorAll('[data-bundle-tab]')];
      const panels = [...root.querySelectorAll('[data-bundle-panel]')];

      const selectTab = (panelId, moveFocus = false) => {
        const nextTab = tabs.find((tab) => tab.dataset.bundleTab === panelId) || tabs[0];
        if (!nextTab) return;

        tabs.forEach((tab) => {
          const active = tab === nextTab;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.bundlePanel !== nextTab.dataset.bundleTab;
        });

        if (moveFocus) nextTab.focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          selectTab(tab.dataset.bundleTab);
          window.history.replaceState(null, '', `#${tab.dataset.bundleTab}`);
          emitAnalytics(root, 'view', { bundle_type: tab.dataset.bundleTab });
        });

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          selectTab(tabs[nextIndex].dataset.bundleTab, true);
        });
      });

      const requestedPanel = window.location.hash.replace('#', '');
      if (panels.some((panel) => panel.dataset.bundlePanel === requestedPanel)) {
        selectTab(requestedPanel);
      }

      const initiallySelectedTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      emitAnalytics(root, 'view', { bundle_type: initiallySelectedTab?.dataset.bundleTab || 'cold-cases' });

      root.addEventListener('bundle:added', (event) => {
        const bundle = event.target.closest?.('product-bundle') || event.target;
        const product = event.detail?.product;
        window.requestAnimationFrame(() => localizeSummaryOptions(root));
        emitAnalytics(root, 'select', {
          bundle_type: bundle.closest('[data-bundle-kind]')?.dataset.bundleKind,
          product_id: product?.querySelector('product-card-info')?.dataset.productId,
          variant_id: event.detail?.variant?.id
        });
      }, true);

      root.addEventListener('bundle:removed', (event) => {
        const bundle = event.target.closest?.('product-bundle') || event.target;
        const variantRow = event.detail?.variant;
        window.requestAnimationFrame(() => localizeSummaryOptions(root));
        emitAnalytics(root, 'remove', {
          bundle_type: bundle.closest('[data-bundle-kind]')?.dataset.bundleKind,
          product_id: variantRow?.product?.querySelector('product-card-info')?.dataset.productId,
          variant_id: variantRow?.dataset.variantId
        });
      }, true);

      root.querySelectorAll('product-bundle').forEach((bundle) => {
        const countElement = bundle.querySelector('[data-bundle-count]');
        const progress = bundle.querySelector('[data-product-bundle-progress-bar]');
        const toggle = bundle.querySelector('.mom-bundle__summary-toggle');
        const template = root.dataset.countTemplate;
        const priceBreakdown = bundle.querySelector('[data-bundle-price-breakdown]');
        const originalRow = bundle.querySelector('[data-bundle-original-row]');
        const originalTotalElement = bundle.querySelector('[data-bundle-original-total]');
        const savingRow = bundle.querySelector('[data-bundle-saving-row]');
        const savingRateElement = bundle.querySelector('[data-bundle-saving-rate]');
        const savingTotalElement = bundle.querySelector('[data-bundle-saving-total]');
        const discountedTotalElement = bundle.querySelector('[data-product-bundle-total-with-currency]');
        const ctaTotalElement = bundle.querySelector('[data-product-bundle-total]');
        const savingsMessage = bundle.querySelector('[data-bundle-saving-message]');

        bundle.querySelectorAll('.product-card').forEach((card) => {
          card.setAttribute('data-selected-label', root.dataset.selectedLabel);
        });

        const update = () => {
          const selectedRows = [...bundle.querySelectorAll('[data-product-bundle-variant]:not([available])')];
          const selected = selectedRows.length;
          const discountRate = selected >= 3 ? 15 : selected >= 2 ? 10 : 0;
          const originalTotal = selectedRows.reduce((subtotal, row) => {
            const price = Number.parseInt(row.querySelector('[data-product-bundle-variant-price]')?.dataset.price || '0', 10);
            const quantity = Number.parseInt(row.querySelector('quantity-input')?.value || '1', 10);
            return subtotal + (Number.isFinite(price) ? price : 0) * (Number.isFinite(quantity) ? quantity : 1);
          }, 0);
          const savingTotal = discountRate === 0 ? 0 : selectedRows.reduce((saving, row) => {
            const price = Number.parseInt(row.querySelector('[data-product-bundle-variant-price]')?.dataset.price || '0', 10);
            const quantity = Number.parseInt(row.querySelector('quantity-input')?.value || '1', 10);
            const lineTotal = (Number.isFinite(price) ? price : 0) * (Number.isFinite(quantity) ? quantity : 1);
            return saving + Math.round(lineTotal * discountRate / 100);
          }, 0);
          const discountedTotal = Math.max(0, originalTotal - savingTotal);
          const currencyCode = root.dataset.currencyCode || 'GBP';
          const moneyFormatter = new Intl.NumberFormat(
            root.dataset.moneyLocale || root.dataset.locale || 'en',
            {
              style: 'currency',
              currency: currencyCode,
              currencyDisplay: 'narrowSymbol'
            }
          );
          const formatMoney = (amount, withCurrency = false) => {
            const formatted = moneyFormatter.format(amount / 100);
            return withCurrency ? `${formatted}\u00a0${currencyCode}` : formatted;
          };

          if (countElement) countElement.textContent = template.replace('[selected]', String(selected));
          if (progress) progress.setAttribute('aria-valuenow', String(Math.min(selected, 2)));
          bundle.dataset.selectedCount = String(selected);
          bundle.dataset.discountRate = String(discountRate);
          bundle.dataset.originalTotal = String(originalTotal);
          bundle.dataset.savingTotal = String(savingTotal);
          bundle.dataset.discountedTotal = String(discountedTotal);

          if (originalTotalElement) originalTotalElement.innerHTML = formatMoney(originalTotal, true);
          if (savingTotalElement) savingTotalElement.innerHTML = formatMoney(savingTotal, true);
          if (savingRateElement) savingRateElement.textContent = `(${discountRate}%)`;
          if (discountedTotalElement) discountedTotalElement.innerHTML = formatMoney(discountedTotal, true);
          if (ctaTotalElement) ctaTotalElement.innerHTML = formatMoney(discountedTotal);

          const hasDiscount = discountRate > 0;
          originalRow?.toggleAttribute('hidden', !hasDiscount);
          savingRow?.toggleAttribute('hidden', !hasDiscount);
          priceBreakdown?.classList.toggle('has-discount', hasDiscount);

          bundle.querySelectorAll('[data-bundle-saving-tier]').forEach((tier) => {
            const threshold = Number(tier.dataset.bundleSavingTier || 0);
            const unlocked = selected >= threshold;
            const current = threshold === (discountRate === 15 ? 3 : discountRate === 10 ? 2 : 0);
            const next = !unlocked && threshold === (selected < 2 ? 2 : 3);
            tier.classList.toggle('is-unlocked', unlocked);
            tier.classList.toggle('is-current', current);
            tier.classList.toggle('is-next', next);
            if (current) tier.setAttribute('aria-current', 'step');
            else tier.removeAttribute('aria-current');
          });

          if (savingsMessage) {
            const messages = [
              root.dataset.savingsProgressZero,
              root.dataset.savingsProgressOne,
              root.dataset.savingsProgressTwo,
              root.dataset.savingsProgressThree
            ];
            savingsMessage.textContent = messages[Math.min(selected, 3)] || messages[0] || '';
          }

          const atMaximum = selected >= Number(bundle.dataset.maximum || 3);
          bundle.closest('.product-bundle-wrapper')?.querySelectorAll('.product-card').forEach((card) => {
            const submit = card.querySelector('form[is="product-bundle-form"] [type="submit"]');
            const languageShell = card.closest('[data-language-shell]');
            const languageReady = !languageShell || languageShell.dataset.languageReady === 'true';
            if (submit) submit.disabled = !languageReady || card.hasAttribute('locked') || atMaximum;
          });

          window.requestAnimationFrame(() => localizeSummaryOptions(root));
        };

        bundle._momBundleUpdate = update;

        bundle.addEventListener('bundle:added', () => queueMicrotask(update));
        bundle.addEventListener('bundle:removed', () => queueMicrotask(update));
        bundle.addEventListener('change', () => window.setTimeout(update, 320));

        toggle?.addEventListener('click', () => {
          queueMicrotask(() => toggle.setAttribute('aria-expanded', String(bundle.classList.contains('active'))));
        });

        update();
      });

      document.addEventListener('ajaxProduct:added', () => {
        queueMicrotask(() => {
          const submittedBundle = [...root.querySelectorAll('product-bundle')].find((bundle) =>
            bundle.querySelector('[data-product-bundle-submit][aria-busy="true"]')
          );

          if (submittedBundle) {
            emitAnalytics(root, 'add', {
              bundle_type: submittedBundle.closest('[data-bundle-kind]')?.dataset.bundleKind,
              item_count: Number(submittedBundle.dataset.selectedCount || submittedBundle.bundleCount || 0)
            });
          }

          root.querySelectorAll('product-bundle').forEach((bundle) => {
            bundle._momBundleUpdate?.();
          });
        });
      });

      root.addEventListener('change', (event) => {
        if (!event.target.matches?.('.variant-input-wrapper select')) return;
        const card = event.target.closest('.product-card');
        window.requestAnimationFrame(() => localizeVariantControls(root, card || root));
      });

      root.addEventListener('variant:change', (event) => {
        const card = event.target.closest?.('.product-card');
        window.requestAnimationFrame(() => localizeVariantControls(root, card || root));
      });

      Promise.all([
        customElements.whenDefined('variant-picker'),
        customElements.whenDefined('product-bundle'),
        customElements.whenDefined('product-bundle-form')
      ]).then(() => {
        initLanguageVariants(root);
        localizeVariantControls(root);
        root.dataset.bundleReady = 'true';
      });
    };

    document.querySelectorAll('[data-mom-bundle]').forEach(initSection);
    document.addEventListener('shopify:section:load', (event) => {
      initSection(event.target.querySelector('[data-mom-bundle]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mom-case-archive"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.querySelectorAll('[data-enhanced]').forEach(element => { element.hidden = false; });
    const cards = [...root.querySelectorAll('[data-case-card]')];
    const filters = [...root.querySelectorAll('[data-filter]')];
    const status = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-empty]');
    let genre = 'all';
    const filter = () => {
      let count = 0;
      cards.forEach(card => {
        const genreMatch = genre === 'all' || card.dataset.genre === genre;
        card.hidden = !genreMatch;
        if (!card.hidden) count++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === genre)));
      status.textContent = `${String(count).padStart(2, '0')} ${count === 1 ? status.dataset.labelSingle : status.dataset.label}`;
      empty.hidden = count !== 0;
    };
    filters.forEach(button => button.addEventListener('click', () => { genre = button.dataset.filter; filter(); }));
    root.querySelector('[data-reset]').addEventListener('click', () => { genre = 'all'; filter(); filters[0].focus(); });
    filter();
    root.querySelectorAll('a[href^="#cc-"]').forEach(link => link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      target.setAttribute('tabindex', '-1');
      window.history.replaceState(null, '', link.hash);
      window.requestAnimationFrame(() => {
        target.focus({ preventScroll: true });
        const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'instant' });
      });
    }));
    const cartConfig = JSON.parse(root.querySelector('[data-cart-config]').textContent);
    const eligibleProducts = new Set(cartConfig.eligible.map(String));
    const cartMessages = cartConfig.messages;
    const renderCartProgress = (cart) => {
      const count = cart.items.reduce((total, item) => total + (eligibleProducts.has(String(item.product_id)) ? item.quantity : 0), 0);
      const discounts = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(item => (item.line_level_discount_allocations || []).map(d => d.discount_application))];
      const applied = discounts.map(d => d.title || '').join(' ');
      let message = count === 0 ? cartMessages.zero : count === 1 ? cartMessages.one : cartMessages.pending;
      if (count >= 2 && applied.includes('MOM BUNDLE 10%')) message = cartMessages.two;
      if (count >= 3 && applied.includes('MOM BUNDLE 15%')) message = cartMessages.three;
      root.querySelectorAll('[data-cart-progress]').forEach(element => { element.textContent = message; });
      root.querySelectorAll('[data-cart-link]').forEach(link => { link.hidden = cart.item_count === 0; });
    };
    const readCart = async () => {
      const response = await fetch(root.dataset.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) throw new Error('cart-read');
      const cart = await response.json();
      renderCartProgress(cart);
      return cart;
    };
    readCart().catch(() => {});
    let unsubscribeCart;
    if (typeof theme !== 'undefined' && theme.pubsub) {
      unsubscribeCart = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, event => {
        if (event.cart && Array.isArray(event.cart.items)) renderCartProgress(event.cart);
      });
    }
    const refreshOnReturn = () => { if (!document.hidden) readCart().catch(() => {}); };
    document.addEventListener('visibilitychange', refreshOnReturn);
    const refreshOnPageShow = (event) => { if (event.persisted) refreshOnReturn(); };
    window.addEventListener('pageshow', refreshOnPageShow);
    root.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
      if (unsubscribeCart) unsubscribeCart();
      document.removeEventListener('visibilitychange', refreshOnReturn);
      window.removeEventListener('pageshow', refreshOnPageShow);
    }, { once: true });

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const fileButtons = [...root.querySelectorAll('[data-pick-file]')];
    const fileSheets = [...root.querySelectorAll('[data-file-sheet]')];
    const featuredLink = root.querySelector('[data-featured-case-link]');
    fileButtons.forEach(button => button.addEventListener('click', () => {
      fileButtons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      fileSheets.forEach((sheet, index) => {
        const position = (index - fileButtons.indexOf(button) + fileSheets.length) % fileSheets.length;
        sheet.dataset.fileSide = position === 0 ? 'front' : position === 1 ? 'right' : 'left';
        const active = sheet.dataset.fileSheet === button.dataset.pickFile;
        sheet.classList.toggle('is-active', active);
        sheet.setAttribute('aria-hidden', String(!active));
        sheet.tabIndex = active ? 0 : -1;
      });
      featuredLink.href = button.dataset.caseUrl;
      featuredLink.querySelector('span').textContent = button.dataset.caseTitle;
    }));
    const evidenceTabs = [...root.querySelectorAll('[data-evidence-tab]')];
    const evidencePanels = [...root.querySelectorAll('[data-evidence-panel]')];
    const selectEvidence = (tab, focus = false) => {
      evidenceTabs.forEach(item => {
        item.setAttribute('aria-selected', String(item === tab));
        item.tabIndex = item === tab ? 0 : -1;
      });
      evidencePanels.forEach(panel => {
        const selected = panel.dataset.evidencePanel === tab.dataset.evidenceTab;
        panel.hidden = !selected;
        if (selected && !reducedMotion.matches) {
          panel.getAnimations().forEach(animation => animation.cancel());
          panel.animate([{ opacity: .25, transform: 'translateY(8px)' }, { opacity: 1, transform: 'translateY(0)' }], { duration: 350, easing: 'cubic-bezier(.2,.7,.2,1)' });
        }
      });
      if (focus) tab.focus();
    };
    evidenceTabs.forEach((tab, index) => {
      tab.addEventListener('click', () => selectEvidence(tab));
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % evidenceTabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + evidenceTabs.length) % evidenceTabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = evidenceTabs.length - 1;
        else return;
        event.preventDefault();
        selectEvidence(evidenceTabs[next], true);
      });
    });
    let revealObserver;
    if (!reducedMotion.matches && 'IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.animate([{ transform: 'translateY(12px)', opacity: .3 }, { transform: 'translateY(0)', opacity: 1 }], { duration: 550, easing: 'cubic-bezier(.2,.7,.2,1)' });
          revealObserver.unobserve(entry.target);
        });
      }, { threshold: .4 });
      root.querySelectorAll('.cc-step-icon').forEach(item => revealObserver.observe(item));
    }
    const dock = root.querySelector('[data-mobile-dock]');
    const catalogue = root.querySelector('.cc-catalogue');
    let scheduled = false;
    const updateDock = () => {
      dock.hidden = !window.matchMedia('(max-width: 600px)').matches || catalogue.getBoundingClientRect().bottom > 120;
      scheduled = false;
    };
    const onScroll = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(updateDock);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateDock();
    const section = root.closest('.shopify-section');
    if (section) section.addEventListener('shopify:section:unload', () => {
      if (revealObserver) revealObserver.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }, { once: true });
  };
  document.querySelectorAll('[data-case-archive]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-case-archive]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();
})();
